<!--
	CanvasPath  扩展nut-signture组件
	支持获取路径参数
 -->
<template>
	<div :class="classes">
		<div class="nut-signature-inner" ref="wrap">
			<canvas
				ref="canvas"
				:height="canvasHeight"
				:width="canvasWidth"
				v-if="() => isCanvasSupported()"
			>
				<p>当前浏览器不支持canvas</p>
			</canvas>
		</div>
	</div>
</template>
<script>
import { ref, reactive, onMounted, computed, toRefs, markRaw } from 'vue';
export default {
	props: {
		customClass: {
			type: String,
			default: '',
		},
		lineWidth: {
			type: Number,
			default: 2,
		},
		strokeStyle: {
			type: String,
			default: '#000',
		},
		type: {
			type: String,
			default: 'png',
		},
		unSupportTpl: {
			type: String,
			default: '',
		},
	},
	components: {},
	emits: ['confirm', 'clear'],
	setup(props, { emit, expose }) {
		const canvas = ref(null);
		const wrap = ref(null);
		const classes = computed(() => {
			const prefixCls = 'nut-canvas';
			return {
				[prefixCls]: true,
				[`${props.customClass}`]: props.customClass,
			};
		});
		const state = reactive({
			canvasHeight: 0,
			canvasWidth: 0,
			ctx: null,
			isSupportTouch: 'ontouchstart' in window,
			events: ['touchstart', 'touchmove', 'touchend', 'touchleave'],
		});
		const lines = markRaw([]);
		const lineParams = markRaw([]);
		const isCanvasSupported = () => {
			let elem = document.createElement('canvas');
			return !!(elem.getContext && elem.getContext('2d'));
		};
		const addEvent = () => {
			canvas.value.addEventListener(
				state.events[0],
				startEventHandler,
				false
			);
		};
		const startEventHandler = (event) => {
			event.preventDefault();
			state.ctx.beginPath();
			state.ctx.lineWidth = props.lineWidth;
			state.ctx.strokeStyle = props.strokeStyle;
			let evt = state.isSupportTouch ? event.touches[0] : event;
			let coverPos = canvas.value.getBoundingClientRect();
			let mouseX = evt.clientX - coverPos.left;
			let mouseY = evt.clientY - coverPos.top;
			lineParams.push({
				s: `${mouseX},${mouseY}`,
				e: `${mouseX},${mouseY}`,
				c: props.strokeStyle,
				w: props.lineWidth,
			});
			canvas.value.addEventListener(
				state.events[1],
				moveEventHandler,
				false
			);
			canvas.value.addEventListener(
				state.events[2],
				endEventHandler,
				false
			);
			canvas.value.addEventListener(
				state.events[3],
				leaveEventHandler,
				false
			);
		};
		const moveEventHandler = (event) => {
			event.preventDefault();
			let evt = state.isSupportTouch ? event.touches[0] : event;
			let coverPos = canvas.value.getBoundingClientRect();
			let mouseX = evt.clientX - coverPos.left;
			let mouseY = evt.clientY - coverPos.top;
			lineParams.push({
				e: `${mouseX},${mouseY}`,
			});
			state.ctx.lineTo(mouseX, mouseY);
			state.ctx.stroke();
		};
		const endEventHandler = (event) => {
			event.preventDefault();
			lines.push([...lineParams]);
			lineParams.length = 0;
			canvas.value.removeEventListener(
				state.events[1],
				moveEventHandler,
				false
			);
			canvas.value.removeEventListener(
				state.events[2],
				endEventHandler,
				false
			);
		};
		const leaveEventHandler = (event) => {
			event.preventDefault();
			canvas.value.removeEventListener(
				state.events[1],
				moveEventHandler,
				false
			);
			canvas.value.removeEventListener(
				state.events[2],
				endEventHandler,
				false
			);
		};
		const clear = () => {
			canvas.value.addEventListener(
				state.events[2],
				endEventHandler,
				false
			);
			state.ctx.clearRect(0, 0, state.canvasWidth, state.canvasHeight);
			state.ctx.closePath();
			onClearTrackData();
			emit('clear');
		};
		const confirm = () => {
			onSave(canvas.value);
		};

		const onSave = (canvas) => {
			let dataurl;
			switch (props.type) {
				case 'png':
					dataurl = canvas.toDataURL('image/png');
					break;
				case 'jpg':
					dataurl = canvas.toDataURL('image/jpeg', 0.8);
					break;
			}
			clear();
			emit('confirm', canvas, dataurl);
		};

		const onGetTrackData = () => {
			return lines;
		};

		const getCanvas = () => {
			return canvas.value;
		};
		const onClearTrackData = () => {
			lines.length = lineParams.length = 0;
		};
		onMounted(() => {
			if (isCanvasSupported()) {
				state.ctx = canvas.value.getContext('2d');
				state.canvasWidth = wrap.value.offsetWidth;
				state.canvasHeight = wrap.value.offsetHeight;
				addEvent();
			}
		});

		expose({
			clear,
			confirm,
			onGetTrackData,
			getCanvas,
		});
		return {
			...toRefs(state),
			canvas,
			wrap,
			isCanvasSupported,
			confirm,
			clear,
			classes,
		};
	},
};
</script>
<style lang="scss">
.nut-canvas {
	.nut-signature-inner {
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
</style>
